export default "__VITE_ASSET__CWdV3xPa__"